import styled from "styled-components";

export const StyledUserScheduleItemWrapper = styled.div`
  background-color: #fff;
  border: 1px solid #f0f0f0;
  padding: 1.6rem;
  border-radius: 8px;
`;
export const StyledUserScheduleItemChildWrapper = styled.div`
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-top: 0;
  padding: 1.6rem;
  border-radius: 8px;
`;
export const StyledUserScheduleItemHeadingWrapper = styled.div`
  display: flex;
  gap: 1.6rem;
  justify-content: space-between;
  align-items: center;
`;
export const StyledUserScheduleItemTitleWrapper = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;
export const StyledUserScheduleItemTitleDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: black;
  border-radius: 50%;
`;
export const StyledUserScheduleItemTitle = styled.p`
  color: #1c1726;
  font-size: 1.6rem;
  font-weight: 600;
`;

export const StyledScheduleAvailabilityFormWrapper = styled.div`
  .availability-form-heading {
    font-weight: 400;
    font-size: 1.6rem;
    margin-bottom: 3.3rem;
  }
`;
